import mediaResolutions from '../constants/resolutions';

type homeStylesClasses =
  | 'container'
  | 'grid'
  | 'gridItemContainer'
  | 'gridTextContainer'
  | 'gridTextDescription'
  | 'gridText'
  | 'titleContainer'
  | 'title'
  | 'discoverLink'
  | 'flexEnd'
  | 'coverImage';

const homeStyles: Record<homeStylesClasses, Record<string, any>> = {
  container: {
    backgroundColor: 'darkGrey',
    height: 'calc(100vh - 56px)',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'default',
    animationPlayState: 'paused',
    animation: 'slideIn 1.5s',
    '@keyframes slideIn': {
      '0%': {
        marginLeft: '100%',
      },
      '100%': {
        marginLeft: '0%',
      },
    },
  },
  gridItemContainer: {
    position: 'relative',
    animation: 'slideDown 1.5s',
    '@keyframes slideDown': {
      '0%': {
        marginTop: '70%',
      },
      '100%': {
        marginTop: '0%',
      },
    },
  },
  gridTextContainer: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '3rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#000',
      transition: 'all 0.5s ease-out',
    },
  },
  gridText: {
    color: 'text.secondary',
    fontFamily: 'Cormorant, serif',
    fontSize: '.8em',
    textAlign: 'center',
  },
  gridTextDescription: {
    fontWeight: 'bold',
    fontSize: '1.3em',
    fontStyle: 'italic',
  },
  grid: {
    width: '100%',
    objectFit: 'cover',
    marginBottom: '-10px',
  },
  titleContainer: {
    position: 'absolute',
    bottom: 0,
    right: '0',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [`@media (min-width:${mediaResolutions.sm})`]: {
      bottom: 'unset',
      top: 0,
      right: '-145px',
      transform: 'rotate(90deg)',
      transformOrigin: 'bottom',
      maxWidth: 'calc(100vh - 50px)',
      marginTop: '9rem',
    },
  },
  title: {
    color: 'text.secondary',
    lineHeight: '0.8',
  },
  flexEnd: {
    alignSelf: 'unset',
    [`@media (min-width:${mediaResolutions.sm})`]: {
      alignSelf: 'flex-end',
    },
  },
  discoverLink: {
    textDecoration: 'underline',
    position: 'absolute',
    bottom: 0,
    color: 'text.secondary',
    textTransform: 'capitalize',
    margin: '0 0 8rem .5rem',
    '&:hover': {
      backgroundColor: 'black',
      transition: 'all 0.5s ease-out',
    },
    [`@media (min-width:${mediaResolutions.sm})`]: {
      margin: '0 0 5rem 4rem',
    },
  },
  coverImage: {
    height: 'inherit',
  },
};

export default homeStyles;
